// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto', 'Roboto Fallback'","fontStyle":"normal"},"className":"__className_a42368"};